<template>
<v-layout wrap>
  <v-flex class='ml-1' xs12>
    <v-card dark class='ma-0' flat>
      <v-card-title class='subheading pa-0 ma-0' >
        <v-btn class='mx-0' flat text small v-if='withBack' @click='$emit("close")' >
          <v-icon small >chevron_left</v-icon> Back
        </v-btn>
        <v-divider class='mr-2' vertical ></v-divider>
        <span v-if='template.id' >
          Editing template: {{template.name}}
        </span>
        <span v-else >
          Create a new template
        </span>
        <v-spacer ></v-spacer>
        <v-btn @click='sendExample' :disabled='isDirty' >
          Send test
        </v-btn>
        <v-btn dark
          :loading='request.loading'
          @click='save'
          v-if='isEditMode'
          :disabled='errors.length > 0'
          color='primary' >Save</v-btn>
        <v-btn
          :loading='request.loading'
          @click='save' v-else color='primary' :disabled='errors.length > 0' dark >Create template</v-btn>
      </v-card-title>
      <v-divider></v-divider>
    </v-card>

  </v-flex>
  <v-flex xs6 >
    <v-card flat class='mx-2 my-4' >
      <v-card-title class='pl-0' >
        <v-text-field
          v-model='template.name'
          label='Name'
          hint='A name that will help understand the purpose of this communication' >
        </v-text-field>
        <v-menu
          v-model="showSettings"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" >
              <v-icon>settings</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class='overline' >Advanced settings</v-card-title>
            <v-card-text>
            <template v-if='isAdmin' >
              <v-text-field v-model='template.owner' label='practitioner id' persistent-hint hint='Use 0 to create a default template' >
              </v-text-field>
              <v-switch
                label='This is a shared template'
                v-model='template.shared' >
              </v-switch>
              <hr/>
            </template>
            <template >
              <v-subheader class='pa-0 mb-0 overline mt-3' >Share with your Spaces</v-subheader>
              <!-- <space-picker
                v-model='template.spaces'
                :touch='spaceToucher'
                :return-object='false' >
              </space-picker> -->
              <v-switch
                label='Add to UI'
                v-model='template.allow_ad_hoc_sending' >
              </v-switch>
              <v-select v-model='template.preferred_transport' :items='transports' label='Default sending option' >
              </v-select>
            </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-card-title>
      <v-textarea auto-grow rows='2'
        v-model='template.description'
        label='Description'
        hint='A brief description of the purpose of this template' >
      </v-textarea>

      <v-tabs v-model='activeTab' >
        <v-tab
          @click='setLastFocussed("short-message-textarea")' >{{ $t('tabs.short') }}</v-tab>
        <v-tab
          @click='setLastFocussed("email-content")' >{{ $t('tabs.long') }}
        </v-tab>
        <v-spacer></v-spacer>
        <help-popover class='mt-3 mr-1' >
          <v-subheader class='overline ml-0 pl-0' >
            {{ $t('info.merge_tags_title') }}
          </v-subheader>
          <p>{{ $t('info.merge_tags') }}</p>
          <p>{{ $t('info.merge_tags_example') }}</p>
        </help-popover>
        <v-autocomplete
          small box label='Merge tags'
          v-model='selectedMergeTag'
          @change='insertVariable'
          :items='merge_tags'
          return-object
          item-text='text' item-value='value' >
        </v-autocomplete>

        <v-tabs-items v-model='activeTab' >
          <v-divider></v-divider>
          <v-tab-item >
            <v-textarea box counter auto-grow persistent-hint :no-resize='false'
              id='short-message-textarea'
              @focus='setLastFocussed("short-message-textarea")'
              v-model='template.short_message'
              :rows='25'
              :label='$t("forms.shortmessage.label")'
              :hint='$t("forms.shortmessage.hint")' >
            </v-textarea>
          </v-tab-item>
          <v-tab-item >
            <v-text-field box
              id='email-subject'
              v-model='template.subject'
              @focus='setLastFocussed("email-subject")'
              :label='$t("forms.email.subject")' >
            </v-text-field>
            <v-textarea auto-grow box :no-resize='false'
              id='email-content' :rows='25'
              @focus='setLastFocussed("email-content")'
              v-model='template.message'
              :label='$t("forms.email.content")' >
            </v-textarea>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>

  </v-flex>
  <v-flex xs6>
    <v-card dark class=' mx-2 my-4' >
      <v-card-title class='subheading pb-1' >
        {{ $t('titles.preview.main') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if='template.short_message || template.message || template.subject' >
        <div v-if='template.short_message' >
          <h3 class='overline mt-3' >{{ $t('titles.preview.shortmessage') }}</h3>
          <v-textarea :value='parsedShortMessage' auto-grow box readonly >
          </v-textarea>
        </div>
        <div v-if='template.subject || template.message' >
          <h3 class='overline mt-3' >{{ $t('titles.preview.email') }}</h3>
          <strong>Subject:</strong> {{parsedSubject}}
          <div>
            <strong class='overline'>Message:</strong><br/>
            <div v-text="parsedMessage" ></div>
          </div>
        </div>
        <template v-if='isAdmin' >
          <h3 class='overline mt-4' >Raw data</h3>
          <pre>{{payload}}</pre>
        </template>
      </v-card-text>
      <v-card-text v-else >
        <v-icon >info</v-icon>
        Start typing your message and the preview will show up here.
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs12>
    <v-divider></v-divider>
    <v-card flat>
      <v-card-actions >
        <!-- <v-btn flat text @click='$emit("close")' >Cancel</v-btn> -->
        <v-spacer></v-spacer>
        <v-btn
          @click='save'
          v-if='isEditMode'
          :loading='request.loading'
          :disabled='errors.length > 0'
          color='primary' >Save</v-btn>
        <v-btn
          @click='save' v-else
          color='primary'
          :loading='request.loading'
          :disabled='errors.length > 0' >Create template</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</template>
<script>
import Vue from 'vue'
import marked from 'marked'
import Mustache from 'mustache'
import HelpPopover from '@/components/ui/HelpPopover'
import SpacePicker from '@/components/pickers/SpacePicker'
import axios from 'axios'

import {MERGE_TAGS} from './mergetags'

export default {
  name: 'CommunicationTemplateForm',
  props: {
    value: { type: Object },
    contextType: { type: String, required: true },
    withBack: { type: Boolean, default: true }
  },
  components: {HelpPopover, SpacePicker},
  data () {
    return {
      reqId: 'save-communication-template',
      activeTab: 0,
      spaceToucher: 1,
      isDirty: false,
      showSettings: false,
      selectedMergeTag: null,
      merge_tags: MERGE_TAGS,
      mergeTagsMoreInfo: false,
      settings: {
        customPractitionerId: null
      },
      transports: ['sms', 'email'],
      lastFocussed: 'short-message-textarea',
      textfieldLookup: {
        'short-message-textarea': 'short_message',
        'email-subject': 'subject',
        'email-content': 'message'
      },
      // merge_tags: MERGE_TAGS,
      exampleObjects: {
        'Appointment': {
          title: 'Jane Soap',
          currency: 'ZAR',
          price: '100.00',
          starttime_formatted: {
            zoned_date_formatted: 'Fri 20 Sep 2019',
            zoned_time_formatted: '11:30 am'
          }
        }
      },
      exampleContext: {
        sender: {
          first_name: 'Jane',
          last_name: 'Soap',
          full_name: 'Jane Soap',
          email: 'jane@spap.com',
          phone_number: '+278312345678'
        },
        recipient: {
          first_name: 'Joe',
          last_name: 'Soap',
          full_name: 'Joe Soap',
          email: 'joe@spap.com',
          phone_number: '+278312345678'
        }
      },
      template: {
        allow_ad_hoc_sending: false,
        is_active: true,
        subject: '',
        short_message: '',
        message: ''
      }
    }
  },
  watch: {
    payloadString () {
      this.isDirty = true
      this.spaceToucher++
    },
    requestStatus () {
      if (this.requestStatus > 0) {
        if (this.requestStatus < 300) {
          this.isDirty = false
        }
      }
    },
    value () {
      if (this.value) {
        this.template = JSON.parse(JSON.stringify(this.value)) // make a copy
      } else {
        if (this.template && this.template.id) {
          Vue.set(this.template, 'name', '')
          Vue.set(this.template, 'description', '')
          Vue.set(this.template, 'subject', '')
          Vue.set(this.template, 'short_message', '')
          Vue.set(this.template, 'message', '')
          Vue.set(this.template, 'allow_ad_hoc_sending', false)
          Vue.set(this.template, 'is_active', true)
        }
      }
    }
  },
  computed: {
    parsedMessage () {
      return this.parse(this.template.message, true)
    },
    parsedShortMessage () {
      return this.parse(this.template.short_message, false)
    },
    parsedSubject () {
      return this.parse(this.template.subject, false)
    },
    isEditMode () {
      return 'id' in this.template
    },
    isAdmin () {
      return this.me.is_admin
    },
    errors () {
      return []
    },
    request () {
      return this.$store.getters.getRequestById(this.reqId)
    },
    requestStatus () {
      return this.request.status
    },
    payloadString () {
      return JSON.stringify(this.payload)
    },
    payload () {
      let payload = {
        is_active: true,
        owner: this.template.owner,
        allow_ad_hoc_sending: this.template.allow_ad_hoc_sending,
        name: this.template.name,
        description: this.template.description,
        // ui_action_name: this.template.ui_action_name,
        slug: this.template.slug,
        preferred_transport: this.template.preferred_transport,
        spaces: this.template.spaces,
        subject: this.template.subject,
        short_message: this.template.short_message,
        message: this.template.message,
        shared: this.template.shared
      }
      if (!this.isAdmin) {
        payload['owner'] = this.me.id
      }
      return payload
      // return JSON.stringify(payload)
    }
  },
  methods: {
    insertVariable (item) {
      if (!this.lastFocussed) {
        window.alert('Not sure which textfield you want to put this variable in. It is possible you browser doesn\'t support this feature')
      }
      let el = document.getElementById(this.lastFocussed)
      let insertable = '{{' + item.key + '}}'
      el.setRangeText(insertable)
      let key = this.textfieldLookup[this.lastFocussed]
      Vue.set(this.template, key, el.value)
    },
    setLastFocussed (field) {
      this.lastFocussed = field
      if (!field) {
        if (this.activeTab === 0) {
          this.lastFocussed = 'short-message-textarea'
        }
        if (this.activeTab === 1) {
          this.lastFocussed = 'email-content'
        }
      }
    },
    parse (message, withMarkdown = false) {
      if (withMarkdown) {
        message = marked(message, { sanitize: true })
      }
      try {
        let context = Object.assign(
          this.exampleContext,
          this.exampleObjects[this.contextType]
        )
        return Mustache.render(message, context)
      } catch (err) {
        this.errorMessage = 'There is an error in your template'
        return 'Error. Unable to parse template'
      }
    },
    sendExample () {
      let url = this.$communicationguru.baseUrl + '/templates/' + this.template.id + '/send_example/'
      let headers = this.$communicationguru.headers
      console.log(headers)
      let options = { url, headers, method: 'post' }
      axios(options)
        .then((res) => {
          window.alert('Test message sent.')
        })
        .catch((res) => {
          window.alert('Error sending message')
        })
    },
    save () {
      let req = this.$communicationguru.resource('template').id(this.reqId)
      let data = JSON.stringify(this.payload)
      if (this.template.id) {
        req.save(this.template.id, data)
      } else {
        req.create(data)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          preview: {
            main: 'Preview',
            email: 'Example email',
            shortmessage: 'Example short message'
          },
          preferences: 'Preferences',
          variables: 'Merge tags'
        },
        tabs: {
          short: 'Short messages',
          long: 'Email'
        },
        forms: {
          email: {
            subject: 'Message subject',
            content: 'Message content'
          },
          shortmessage: {
            label: 'Text for short messages',
            hint: 'The text that will be used for SMSes and in-app notifications'
          }
        },
        info: {
          merge_tags_title: 'What is a merge tag?',
          merge_tags: 'Merge tags let you insert content into your messages from objects like appointments and invoices.',
          merge_tags_example: 'For example, you might use a merge tag to provide the start time of an appointment in your message.'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommunicationTemplateForm.vue?45ed6988